import { useHistory } from 'react-router';

import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { PropertyHelper } from 'src/helpers/PropertyHelper';
import { IProperty } from 'src/interfaces/Property';
import { getPropertyData } from 'src/services/PropertiesService';
import { URL_SET_SOURCES } from 'src/types/UrlSetSources';

interface PropertyDataResult {
	property: IProperty;
	sourceMode: URL_SET_SOURCES;
	isNew: boolean;
}

export function usePropertyData(propertyId: string): UseQueryResult<PropertyDataResult> {
	const history = useHistory();

	return useQuery<PropertyDataResult>(
		['propertySettings', propertyId],
		async (): Promise<PropertyDataResult> => {
			const createDraftProperty = (): PropertyDataResult => {
				const baseUrl = new URLSearchParams(history.location.search).get('baseurl');
				let newProperty = PropertyHelper.getDefaultPropertyFromTemplate(baseUrl);
				newProperty = PropertyHelper.ensurePropertyHasDefaultRule(newProperty);
				return {
					property: newProperty,
					sourceMode: URL_SET_SOURCES.URL_DISCOVERY,
					isNew: true
				};
			};

			if (PropertyHelper.isPropertyInDraftMode(propertyId)) {
				return createDraftProperty();
			}

			const propertyFromServer = await getPropertyData(propertyId);
			if (!propertyFromServer) {
				return createDraftProperty();
			}

			return {
				property: propertyFromServer as IProperty,
				sourceMode: propertyFromServer.urlSetConfiguration.source,
				isNew: false
			};
		},
		{
			refetchOnWindowFocus: false,
			retry: false,
			staleTime: Infinity
		}
	);
}
